import Accounts from './Accounts';

export { default as AccountsSlice } from './Accounts.slice';
export { hideAllModals } from './Accounts.slice';

export default Accounts;
